import { addDays, toDateInputString, toIsoString, enrichPolicy } from './demoUtils';

function resolveInsuranceTypeId(insuranceTypeId, insuranceTypes) {
  const requestedType = insuranceTypes.find((item) => item.id === insuranceTypeId);
  if (requestedType) {
    return requestedType.id;
  }

  const generalLiability = insuranceTypes.find((item) => item.name === 'General Liability');
  return generalLiability?.id || insuranceTypes[0]?.id || null;
}

export function createVendorRecord(vendorData, { id, now = new Date() }) {
  return {
    id,
    name: vendorData.name || 'Vendor',
    contact_name: vendorData.contact_name || '',
    contact_email: vendorData.contact_email || '',
    contact_phone: vendorData.contact_phone || '',
    address: vendorData.address || '',
    status: vendorData.status || 'active',
    is_self: Boolean(vendorData.is_self),
    created_at: toIsoString(vendorData.created_at || now),
    updated_at: toIsoString(now),
  };
}

export function createInsuranceTypeRecord(typeData, { id, nextFieldId, now = new Date() }) {
  const fields = typeData.fields || typeData.custom_fields || [];

  return {
    id,
    name: typeData.name || 'Insurance Type',
    user_id: typeData.user_id || 999,
    created_at: toIsoString(typeData.created_at || now),
    custom_fields: fields.map((field, index) => ({
      id: field.id || nextFieldId + index,
      field_name: field.field_name || field.name || 'Field',
      field_type: field.field_type || field.data_type || 'text',
      required: Boolean(field.required),
    })),
  };
}

export function createPolicyRecord(policyData, { id, vendors, insuranceTypes, now = new Date() }) {
  const insuranceTypeId = resolveInsuranceTypeId(policyData.insurance_type_id, insuranceTypes);
  const effectiveDate = policyData.effective_date || addDays(now, -30);
  const expirationDate = policyData.expiration_date || addDays(now, 30);

  const rawPolicy = {
    id,
    vendor_id: policyData.vendor_id,
    insurance_type_id: insuranceTypeId,
    policy_name: policyData.policy_name || '',
    policy_number: policyData.policy_number || '',
    insurer_name: policyData.insurer_name || '',
    effective_date: toDateInputString(effectiveDate),
    expiration_date: toDateInputString(expirationDate),
    general_liability_occurrence_limit: policyData.general_liability_occurrence_limit ?? null,
    general_liability_aggregate_limit: policyData.general_liability_aggregate_limit ?? null,
    workers_comp_limit: policyData.workers_comp_limit ?? null,
    additional_insured_status: Boolean(policyData.additional_insured_status),
    custom_field_definitions: policyData.custom_field_definitions || [],
    custom_field_values: policyData.custom_field_values || {},
    created_at: toIsoString(policyData.created_at || now),
    updated_at: toIsoString(now),
  };

  return {
    rawPolicy,
    policy: enrichPolicy(rawPolicy, vendors, insuranceTypes, now),
  };
}
